export default {
  dockingAccessApi: {
    access: {
      applications: '/api/dockingAccess/applications',
      saveOrUpdateApplication: '/api/dockingAccess/saveOrUpdateApplication',
      delApplications: '/api/dockingAccess/delApplications'
    },
    accessLog: {
      getLogs: '/api/dockingAccessLog/getLogs'
    },
    rmtjSupport: {
      getLogs: '/api/rmtjReceive/getLogs'
    }
  }
}